import { updatePostPayment, createDonationSubscription } from '../../../utils/apis';
import { IPaymentObject } from '../../../utils/types';

export interface PaymentCallbackProps {
  paymentObject: IPaymentObject;
  closePopup: () => void;
  onSuccess?: () => void;
  onError?: (error: any) => void;
}

export const handlePaymentSuccess = async (
  response: any,
  props: PaymentCallbackProps
) => {
  try {
    console.log('Payment success:', response);

    if (response?.data) {
      response = response?.data;
    }

    if (!response.isSuccess) {
      console.log('Payment was not successful, treating as error');
      await handlePaymentError(response, props);
      return;
    }

    const payabaliResponse = {
      isSuccess: response.isSuccess,
      responseData: response.responseData || response
    };

    const referenceId = response?.responseData?.referenceId || response?.referenceId || '';

    // Check if this is a recurring donation
    const isDonationSubscription =
      props.paymentObject.paymentType === 'DONATION' && props.paymentObject.isRecurring;

    if (isDonationSubscription) {
      // For recurring donations, create a subscription via the backend
      const customerId = response?.responseData?.customerId || response?.customerId || '';
      const methodReferenceId = response?.responseData?.referenceId || response?.responseData?.methodReferenceId || response?.referenceId || '';

      console.log('Creating donation subscription - customerId:', customerId, 'methodReferenceId:', methodReferenceId);

      await createDonationSubscription({
        amount: props.paymentObject.amount,
        frequency: props.paymentObject.frequency,
        startDate: props.paymentObject.startDate,
        firstName: props.paymentObject.donationData?.firstName || '',
        lastName: props.paymentObject.donationData?.lastName || '',
        email: props.paymentObject.donationData?.email || '',
        phoneNumber: props.paymentObject.donationData?.phoneNumber,
        address: props.paymentObject.donationData?.address,
        specialDesignation: props.paymentObject.donationData?.specialDesignation,
        paymentAggregatorResponse: {
          customerId: customerId,
          methodReferenceId: methodReferenceId,
        },
        metadata: {
          donationType: props.paymentObject.donationType || 'General Donation',
        },
      });

      props.closePopup();
      if (props.onSuccess) {
        props.onSuccess();
      }
    } else {
      // For one-time donations (and all other payments), use existing flow
      const metadata = {
        phoneNumber: props.paymentObject.donationData?.phoneNumber,
        address: props.paymentObject.donationData?.address,
        specialDesignation: props.paymentObject.donationData?.specialDesignation,
        donationType: props.paymentObject.donationType || 'General Donation',
      };

      await updatePostPayment(
        props.paymentObject.amount,
        referenceId,
        payabaliResponse,
        props.paymentObject.identityId,
        props.paymentObject.isRecurring,
        props.paymentObject.startDate,
        props.paymentObject.frequency,
        props.paymentObject.paymentType,
        props.paymentObject.donationData?.firstName,
        props.paymentObject.donationData?.lastName,
        props.paymentObject.donationData?.email,
        metadata
      );

      props.closePopup();
      if (props.onSuccess) {
        props.onSuccess();
      }
    }
  } catch (error) {
    console.error('Error updating payment:', error);
    if (props.onError) {
      props.onError(error);
    }
  }
};

export const handlePaymentError = async (
  errors: any,
  props: PaymentCallbackProps
) => {
  try {
    console.log('Payment error:', errors);

    const payabaliResponse = {
      isSuccess: errors.isSuccess || false,
      responseData: errors.responseData || errors
    };

    const referenceId = errors?.responseData?.referenceId || errors?.referenceId || '';

    // Only call updatePostPayment for non-recurring donations (one-time)
    // For recurring, there's no transaction to record on failure since we only stored the method
    if (!(props.paymentObject.paymentType === 'DONATION' && props.paymentObject.isRecurring)) {
      await updatePostPayment(
        props.paymentObject.amount,
        referenceId,
        payabaliResponse,
        props.paymentObject.identityId,
        props.paymentObject.isRecurring,
        props.paymentObject.startDate,
        props.paymentObject.frequency,
        props.paymentObject.paymentType,
        props.paymentObject.donationData?.firstName,
        props.paymentObject.donationData?.lastName,
        props.paymentObject.donationData?.email
      );
    }

    if (props.onError) {
      props.onError(errors);
    }
  } catch (apiError) {
    console.error('Error updating payment on failure:', apiError);
    if (props.onError) {
      props.onError(apiError);
    }
  }
};
